import OrderProduct from '@/models/OrderProduct'
import BaseCollection from '@/models/collections/BaseCollection'

export default class OrderProductsList extends BaseCollection {
  options () {
    return {
      model: OrderProduct
    }
  }

  routes () {
    return {
      fetch: `${this.API_BASE}/v1/shopping`
    }
  }
}
